import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import AssetAcquisitionDetail from '@/types/table/assetAcquisitionDetail';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetAcquisitionDetailData extends AssetAcquisitionDetail {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetAcquisitionDetailController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetAcquisitionDetailData>>(API_CONTEXT + '/app/assetAcquisitionDetail/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetAcquisitionDetailData>(API_CONTEXT + '/app/assetAcquisitionDetail/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/assetAcquisitionDetail/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/assetAcquisitionDetail/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/assetAcquisitionDetail/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisitionDetail/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisitionDetail/update', params, httpOptions);
  }

  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisitionDetail/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisitionDetail/deleteBatch', params, httpOptions);
  }

  static selectAssetAcquisitionDetailList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<AssetAcquisitionDetailData>(API_CONTEXT + '/app/assetAcquisitionDetail/selectAssetAcquisitionDetailList', params, httpOptions);
  }

  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<AssetAcquisitionDetailData>(API_CONTEXT + '/app/assetAcquisitionDetail/getUserInformation', params, httpOptions);
  }
    static selectAssetAcquisitionDetailEvaluation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<AssetAcquisitionDetailData>(API_CONTEXT + '/app/assetAcquisitionDetail/selectAssetAcquisitionDetailEvaluation', params, httpOptions);
  }
  static updateEvaluationInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<AssetAcquisitionDetailData>(API_CONTEXT + '/app/assetAcquisitionDetail/updateEvaluationInformation', params, httpOptions);
  }

}
